module.exports = __webpack_public_path__ + "img/food-fatig-min.59499809.jpg";